// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewChild, ViewRef, ElementRef, HostListener, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// NGRX
// Service
//Models
import { LayoutUtilsService } from '../../../../../core/_base/crud';
import { DatePipe } from '@angular/common';
import { FunctionPublic } from 'app/views/pages/nfc/dung-chung/__function/common_function';


@Component({
	selector: 'kt-in-chuyen-kho-171123',
	templateUrl: './in-chuyen-kho-171123.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})


export class ChuyenKho171123PrintComponent implements OnInit {

	@Input() masterData: any;
	@Input() detailData: any[];
	constructor(
		private datePipe: DatePipe) {};
		
	/**
	 * On init
	 */
	ngOnInit() {
	}
	
	get_date_nhap_kho(){
		var date = new Date(this.masterData.NgayChuyen);
		return "Ngày "+("0" + date.getDate().toString()).slice(-2)+ "/"+ ("0" + (date.getMonth() + 1).toString()).slice(-2) + "/"+ date.getFullYear(); 
	}
	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	sum_so_luong(){
		// ;
		return this.detailData.length > 0 ? this.detailData.map(x => x.SoLuongChuyenQuiDoi).reduce((a, b) => a + b) : 0;
	}
	sum_so_luong_nhan(){
		// ;
		return this.detailData.length > 0 ? this.detailData.map(x => x.SoLuongNhanQuiDoi).reduce((a, b) => a + b) : 0;
	}
	getLyDo(){
		if(this.masterData.LyDo){
			return this.masterData.LyDo;
		}
		else if(this.detailData.find(x => x.IdDnCtCk != null)){
			const filteredList = this.detailData.filter(x => x.IdDnCtCk !== null);
			// Extract the SoPhieuDeNghi from the filtered list
			const SoPhieuDeNghiList = filteredList.map(x => x.SoPhieuDeNghi);
			return "Theo đề nghị chuyển kho số "+ SoPhieuDeNghiList;
		}
	}
	get_date(){
		var date = new Date();
		return "Ngày "+("0" + date.getDate().toString()).slice(-2)+ "/"+ ("0" + (date.getMonth() + 1).toString()).slice(-2) + "/"+ date.getFullYear(); 
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
}
